import React, {Component} from "react";
import {TextField} from "@mui/material";

export class NormalBox extends Component {
    constructor(props) {
        super(props);
    }

    inputChanged(e) {
        this.props.onAnswerChange(e.target.value, this.props.targetColId);
    }

    render() {
        return (
            <div style={{margin: "10px 0", width: "100%"}}>
                <TextField
                    autoFocus={!this.props.disableAutofocus}
                    onChange={this.inputChanged.bind(this)}
                    inputProps={{style: {textAlign: 'center', color: this.props.color, width: "100%", fontSize: 25}}}
                />
            </div>
        )
    }
}
